import { titleize } from '../../utils/helpers';

export const getGraphLayout = ({
  showLegend,
  yAxisTitle,
  altYAxisTitle,
  xAxisType = 'category',
}) => ({
  hoverlabel: { align: 'left' },
  annotations: [
    {
      xref: 'paper',
      yref: 'paper',
      x: 1,
      xanchor: 'right',
      y: 1,
      yanchor: 'bottom',
      text: 'Source: Welligence Energy Analytics',
      showarrow: false,
      font: {
        color: 'lightgrey',
        size: 10,
      },
    },
  ],
  margin: {
    l: yAxisTitle ? 65 : 50,
    r: altYAxisTitle ? 65 : 15,
    b: 60,
    t: 30,
  },
  xaxis: {
    type: xAxisType,
    tickangle: 'auto',
    automargin: true,
  },
  barmode: 'stack',
  legend: {
    x: 1,
    xanchor: 'right',
    y: 1,
    bgcolor: 'rgba(236, 240, 245, 0.8)',
  },
  showLegend,
  ...(yAxisTitle && {
    yaxis: { title: { text: yAxisTitle }, standoff: 10, tickmode: 'sync', automargin: true },
  }),
  ...(altYAxisTitle && {
    yaxis2: {
      title: {
        text: altYAxisTitle,
        standoff: 10,
      },
      overlaying: 'y',
      side: 'right',
      tickformat: ',d',
      rangemode: 'tozero',
    },
  }),
});

export const getChartOptions = (data = []) => {
  return data.map((d) => ({
    value: d,
    label: titleize(d),
  }));
};

export const truncate = (str, length) => {
  if (str.length > length) {
    return `${str.substring(0, length)}...`;
  }

  return str;
};
